import CountUp from 'react-countup'
import { Calendar, CheckCircle2, XCircle, Bell, Tag, Bookmark } from 'lucide-react'
import { Summary } from '../../../components/ui/Summary'
import { AgendaInteligenteController } from '../../../services/controllers/agendaInteligente'
import { useAgendaInteligente } from '../../../store/agendaInteligente/useAgendaInteligente'

export function AgendaInteligenteSummary() {
  const CAgendaInteligente = AgendaInteligenteController()
  useAgendaInteligente(st => st.data.contactStatus)
  const stats = CAgendaInteligente.getStats()

  return (
    <Summary.Root>
      <Summary.Box>
        <Summary.Icon icon={Calendar} />
        <Summary.TextContent>
          <Summary.Title>
            <CountUp end={stats.total} preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Agendamentos</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      <Summary.Box>
        <Summary.Icon icon={CheckCircle2} />
        <Summary.TextContent>
          <Summary.Title>
            <CountUp end={stats.confirmados} preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Confirmados</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      <Summary.Box>
        <Summary.Icon icon={XCircle} />
        <Summary.TextContent>
          <Summary.Title>
            <CountUp end={stats.cancelados} preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Cancelados</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      <Summary.Box>
        <Summary.Icon icon={Bell} />
        <Summary.TextContent>
          <Summary.Title>
            <CountUp end={stats.assinantes} preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Assinantes</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      <Summary.Box>
        <Summary.Icon icon={Bookmark} />
        <Summary.TextContent>
          <Summary.Title>
            <CountUp end={stats.pacotes} preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Pacotes</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      <Summary.Box>
        <Summary.Icon icon={Tag} />
        <Summary.TextContent>
          <Summary.Title>
            <CountUp end={stats.avulsos} preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Avulsos</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

    </Summary.Root>
  )
}
